// For SEO purposes, to keep Google from crawling redundant pages, we will
// append URL parameters after click.
//
// For example, if /explore has already been crawled and a bot sees the link
// /explore?ref=homepage_signup_exploreanddiscover it may consider this a different
// page and crawl it again. By appending the URL parameters after click, we can
// avoid these redundant crawls.
const onClickLinkAppendUrlParams = (event: React.MouseEvent, params: URLSearchParams | { [key: string]: string }) => {
  event.preventDefault();
  const link = event.currentTarget as HTMLAnchorElement;
  const url = new URL(link.href);

  const newParams = new URLSearchParams(url.searchParams);
  if (params instanceof URLSearchParams) {
    params.forEach((value, key) => {
      newParams.append(key, value);
    });
  } else {
    Object.keys(params).forEach(key => {
      newParams.append(key, params[key]);
    });
  }

  link.search = '';
  window.location.href = `${link.href}?${newParams.toString()}`;
};

export default onClickLinkAppendUrlParams;

